import React from "react";

type AlpineKeyLogoProps = {
    size?: number;
    colorPrimary?: string;
    colorAccent?: string;
};

export const AlpineKeyLogo: React.FC<AlpineKeyLogoProps> = ({
                                                                size = 64,
                                                                colorPrimary = "var(--color-primary)",
                                                                colorAccent = "var(--color-success-border)",
                                                            }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 64 64"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12 48L32 16L52 48"
                stroke={colorPrimary}
                strokeWidth="6"
                strokeLinecap="round"
                fill="none"
            />
            <circle cx="32" cy="16" r="5" fill={colorAccent}/>
        </svg>
    );
};